import React, { useState, useEffect } from 'react';
import './InstallPWA.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTimes } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../url';

export default function InstallPWA() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [pwaConfig, setPwaConfig] = useState(null);

    useEffect(() => {
        // Cargar configuración PWA
        fetch(`${baseURL}/pwaGet.php`)
            .then(response => response.json())
            .then(data => {
                setPwaConfig(data.pwa);
                // Solo mostrar popup si PWA está activo
                if (data.pwa && data.pwa.activo === 1) {
                    // Verificar si ya se mostró el popup en esta sesión
                    const popupMostrado = sessionStorage.getItem('pwaPopupMostrado');
                    if (!popupMostrado) {
                        setShowPopup(true);
                        sessionStorage.setItem('pwaPopupMostrado', 'true');
                    }
                }
            })
            .catch(error => console.error('Error al cargar configuración PWA:', error));

        // Capturar el evento beforeinstallprompt
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('Usuario aceptó la instalación');
                } else {
                    console.log('Usuario rechazó la instalación');
                }
                setDeferredPrompt(null);
                setShowPopup(false);
            });
        } else {
            // Si no hay prompt disponible, mostrar instrucciones
            alert('Para instalar la app:\n\nEn Android/Chrome: Toca el menú (⋮) > "Instalar app"\n\nEn iOS/Safari: Toca el ícono de compartir > "Agregar a pantalla de inicio"');
            setShowPopup(false);
        }
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    // No mostrar popup si PWA no está activo o si ya se instaló
    if (!pwaConfig || pwaConfig.activo !== 1 || !showPopup) {
        return null;
    }

    return (
        <div className='installPwaPopup'>
            <div className='installPwaContent'>
                <button className='installPwaClose' onClick={handleClosePopup}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                {pwaConfig.logo && (
                    <img src={pwaConfig.logo} alt="Logo" className='installPwaLogo' />
                )}
                <h3>Instala nuestra App</h3>
                <p>Agrega este sitio a tu pantalla de inicio para acceder más rápido.</p>
                <div className='installPwaBtns'>
                    <button className='btnInstall' onClick={handleInstallClick}>
                        <FontAwesomeIcon icon={faDownload} /> Instalar App
                    </button>
                    <button className='btnClose' onClick={handleClosePopup}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}

// Función auxiliar para manejar la instalación (puede ser llamada desde otros componentes)
export const handleInstallPWA = (deferredPrompt) => {
    if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('Usuario aceptó la instalación');
            } else {
                console.log('Usuario rechazó la instalación');
            }
        });
    } else {
        alert('Para instalar la app:\n\nEn Android/Chrome: Toca el menú (⋮) > "Instalar app"\n\nEn iOS/Safari: Toca el ícono de compartir > "Agregar a pantalla de inicio"');
    }
};



